import React, { PropTypes } from 'react'

import styles from './VisuallyHidden.scss'

const VisuallyHidden = ({ children }) => (
  <span className={styles.default}>
    {children}
  </span>
)

VisuallyHidden.propTypes = {
  children: PropTypes.node,
}

export default VisuallyHidden



// WEBPACK FOOTER //
// ./src/components/VisuallyHidden/VisuallyHidden.js